import smartParkService from "../axios";

export const fieldMoistureService = async(url) => {
	return await (await smartParkService.get(url)).data;
}